export enum SplitterData {
  LEFT_DEFAULT_SIZE = 207,
  LEFT_MIN = 60,
  LEFT_MAX = 380,
  LEFT_THESHOLD = 180,
}
